module.exports = __webpack_public_path__ + "media/images/pic/home/all-fd9d35569612b46af0af6db316ba7051.png";